// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2uEsU","signatureBlock":"Footer_signatureBlock__3r9cx","signature":"Footer_signature__E5FC0"};